import type { OptionsType, OptionType } from '@withjoy/joykit';
import { SelectV1 } from '@withjoy/joykit';
import React from 'react';

type ReplyToSelectorProps = {
  allowedEmails: string[];
  onSelect: (newValue: string) => void;
  value: string;
};

export const ReplyToSelector = ({ value, onSelect, allowedEmails }: ReplyToSelectorProps) => {
  const options: OptionsType<OptionType> = allowedEmails.map(email => {
    return {
      value: email,
      label: email,
    };
  });

  return (
    <SelectV1
      value={{
        label: value,
        value,
      }}
      searchable={false}
      onChange={option => {
        onSelect(option?.value ?? '');
      }}
      options={options}
    />
  );
};
